import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\">\n    <title>icon/基础图标/播放</title>\n    <g id=\"icon-play_icon/基础图标/播放\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <polygon id=\"icon-play_路径-3备份\" fill=\"currentColor\" transform=\"translate(52.5, 48) rotate(-90) translate(-52.5, -48)\" points=\"52.5 76 87.5 20 17.5 20\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play.svg
// module id = ufmG
// module chunks = 3